import React from 'react';

export default function Testimonials() {
  return (
    <section className="py-12 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 text-center">
        <h2 className="text-3xl font-bold mb-8">Future Voices: The Impact We Aim to Create</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Testimonial 1 */}
          <div className="bg-white rounded-lg shadow p-6">
            <p className="italic text-gray-700 mb-4">
              "AquaMind AI solutions have revolutionized our maritime operations. 
              Maintenance costs are down, safety is up, and our crew is more efficient than ever."
            </p>
            <p className="font-semibold text-gray-800">- Maritime CEO</p>
          </div>
          
          {/* Testimonial 2 */}
          <div className="bg-white rounded-lg shadow p-6">
            <p className="italic text-gray-700 mb-4">
              "Since implementing AquaMind AI assistants, our small business 
              has seen a 40% increase in productivity. It's like having a team 
              of experts at our fingertips."
            </p>
            <p className="font-semibold text-gray-800">- Small Business Owner</p>
          </div>
          
          {/* Testimonial 3 */}
          <div className="bg-white rounded-lg shadow p-6">
            <p className="italic text-gray-700 mb-4">
              "The collaboration between our human staff and AquaMind AI agents 
              has created a synergy we never thought possible. We're not replacing 
              humans, we're supercharging them."
            </p>
            <p className="font-semibold text-gray-800">- HR Director</p>
          </div>
        </div>
      </div>
    </section>
  );
}
